<ng-container *transloco="let convert;">
  <trap-focus [enableFocusTrap]="true" [enableArrowKeys]="true">
    <app-modal data-test-id="address-changed-modal-container" [modalId]="modalId">
      <div class="modal__content">
        <div class="modal__body">
          <div class="modal__section">
            <i class="allycon-checkmark text-primary" aria-hidden="true"></i>
            @if (variant === 'physical') {
              <p data-test-id="address-changed-modal-physical-message" [innerHTML]="convert('profileManagement.addressChangedModal.textReceivedAdd', {variant : variant})"></p>
            }
            @if (variant === 'title') {
              <p data-test-id="address-changed-modal-title-message">
                {{convert('profileManagement.addressChangedModal.textWeReceived')}}
              </p>
            }
          </div>
          <div class="modal__actions mt-4 text-center">
            <button data-test-id="address-changed-modal-close-btn" class="btn btn-primary  cancel-btn me-md-2 mb-3 mb-md-0" (click)="close()">{{convert('common.btnClose')}}</button>
          </div>
        </div>
      </div>

      <div class="modal-close-container">
        <button
          data-test-id="address-changed-modal-close-x-btn"
          id="close_x_button"
          class="modal__close-btn"
          [attr.aria-label]="convert('common.modalClose')"
          data-track-elem="icon"
          data-track-name="close"
          data-track-trigger="close"
          data-micromodal-close
          (click)="close()"
          >
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </div>
    </app-modal>
  </trap-focus>
</ng-container>
